import { render, staticRenderFns } from "./tidakMampu.vue?vue&type=template&id=f9b22c4c&"
import script from "./tidakMampu.vue?vue&type=script&lang=js&"
export * from "./tidakMampu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports